import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { key: 2 }
const _hoisted_4 = { key: 3 }

import { onMounted, ref, computed } from 'vue'
import { useThemeStore } from '@/stores/theme';
import GameSerchPageOne from '@/themes/themeOne/home/gameSerchPage.vue';
import GameSerchPageTwo from '@/themes/themeTwo/home/gameSerchPage.vue';
import GameSerchPageThree from '@/themes/themeThree/home/gameSerchPage.vue';
import GameSerchPageFour from '@/themes/themeFour/home/gameSerchPage.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'gameSearchPage',
  setup(__props) {

const isSuccess = ref(false)
const statusRef = ref()
const toastContent = ref('')
const loadingRef = ref()
const themeStore = useThemeStore()

const isLoading = ref(false)


const showError = (message: string) => {
    toastContent.value = message;
    isSuccess.value = false;
    statusRef.value.open()
}
const showSuccess = (message: string) => {
    toastContent.value = message;
    isSuccess.value = true;
    statusRef.value.open()
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_unref(themeStore).themeIndex === 1)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(GameSerchPageOne)
        ]))
      : _createCommentVNode("", true),
    (_unref(themeStore).themeIndex === 2)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(GameSerchPageTwo)
        ]))
      : _createCommentVNode("", true),
    (_unref(themeStore).themeIndex === 3)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createVNode(GameSerchPageThree)
        ]))
      : _createCommentVNode("", true),
    (_unref(themeStore).themeIndex === 4)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createVNode(GameSerchPageFour)
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})